import React from "react";
import { Link } from "react-router-dom";
import "./common.css";

const classifiedData = [
  {
    _id: "b1234567890nkindustries",
    name: "NK KUMAR",
    email: "9360087129@gmail.com",
    password: "9360087129",
    mobileNumber: "9360087129",
    companyName: "N.K.Industries",
    productOrService:
      "Press Tools, Sheet Metal Die, Sheet Metal Cutting Die, Metal Die, Pillar Die Sets",
    imgSrc: "/assets/power-tool99.jpg",
    mainProducts: "Press Tools, Sheet Metal Dies",
    altText: "N.K.Industries - Press Tools, Sheet Metal Dies",
    years: "1 YRS",
    location: "Coimbatore, Tamil Nadu, India",
    tooltipText: "N.K.Industries, Coimbatore, Tamil Nadu",
    rating: "4.7",
    ratingPercent: "92%",
    ratingsCount: "85",
    responseRate: "88%",
    whatsappConfirmed: true,
  },
  {
    _id: "b1234567890hayagreevaya",
    name: "Mr. Sudipta Bhattacharya",
    email: "sudipta.bhattacharya@hayagreevaya.com",
    password: "hayagreevayametalindustries@123",
    mobileNumber: "7702230928",
    companyName: "Hayagreevaya Metal Industries",
    productOrService: "Rock Breaker Chisels",
    imgSrc: "/assets/chiseel99.jpg",
    mainProducts: "Rock Breaker Chisels",
    altText: "Hayagreevaya Metal Industries - Rock Breaker Chisels",
    years: "1 YRS",
    location: "Visakhapatnam, Andhra Pradesh, India",
    tooltipText: "Hayagreevaya Metal Industries, Visakhapatnam, Andhra Pradesh",
    rating: "4.7",
    ratingPercent: "92%",
    ratingsCount: "85",
    responseRate: "88%",
    whatsappConfirmed: true,
  },
  {
    name: "Samarth accessories",
    email: "Samarth@gmail.com",
    mobileNumber: "9033341239",
    companyName: "Samarth accessories",
    productOrService: "Power Tools",
    imgSrc: "/assets/toos.jpg", // You need to provide the correct image path
    altText: "Power Tools - Samarth accessories",
    mainProducts: "Drill machine, Grinder Machine, Saws Tool etc.",
    years: "1 YRS",
    location: "Mumbai, Maharashtra, India",
    tooltipText: "123 Tool Street, Industrial Area, Mumbai, Maharashtra, India",
    rating: "4.7",
    ratingPercent: "94%",
    ratingsCount: "40",
    responseRate: "92%",
  },
  {
    name: "Taher Falak",
    email: "nazarailya@gmail.com",
    mobileNumber: "9158339252",
    companyName: "NAZARAILYS",
    productOrService:
      "Hand Tools, Chain Sprockets, Adhesive, Fasteners, Sheets, Power Tools",
    imgSrc: "/assets/power-tool.jpg", // Placeholder image path
    altText:
      "Hand Tools, Chain Sprockets, Adhesive, Fasteners, Sheets, Power Tools - NAZARAILYS",
    mainProducts:
      "Hand Tools, Chain Sprockets, Adhesive, Fasteners, Sheets, Power Tools",
    years: "1 YRS",
    location: "Aurangabad, Uttar Pradesh",
    tooltipText:
      "Located in Aurangabad, Uttar Pradesh, offering a wide range of hand tools, power tools, and industrial components.",
    rating: "4.6",
    ratingPercent: "92%",
    ratingsCount: "180",
    responseRate: "89%",
  },
  {
    _id: "shantha-kumar-tools",
    name: "Shantha Kumar",
    email: "9841464849@gmail.com",
    password: "9841464849",
    mobileNumber: "9841464849",
    companyName: "Anandh Hardwares",
    statename: "Tamil Nadu",
    cityname: "Chennai",
    productOrService:
      "Air Compressor, Power Tools, Hand Tools, Garden Tools, High Pressure Washers",
    imgSrc: "/assets/anandha-ardware99.jpg",
    mainProducts: "Air Compressor, Power Tools, Hand Tools",
    altText: "Shantha Kumar - Supplier of Tools and Equipment",
    years: "1 YRS",
    location: "Chennai, Tamil Nadu, India",
    tooltipText: "Shantha Kumar - Expert in Tools and Equipment",
    rating: "4.7",
    ratingPercent: "94%",
    ratingsCount: "105",
    responseRate: "89%",
    whatsappConfirmed: true,
  },
  {
    _id: "b1234567890tarakachak",
    name: "Mr. Tarak Achak",
    email: "mstarakachak@gmail.com",
    password: "M/STarakAchak@123",
    mobileNumber: "9436258793",
    companyName: "M/S Tarak Achak Enterprise Pvt Ltd",
    productOrService: "Rock Breaker Chisels",
    imgSrc: "/assets/cjissel9.jpg",
    mainProducts: "Rock Breaker Chisels",
    altText: "M/S Tarak Achak Enterprise Pvt Ltd - Rock Breaker Chisels",
    years: "1 YRS",
    location: "Papum Pare, Arunachal Pradesh, India",
    tooltipText:
      "M/S Tarak Achak Enterprise Pvt Ltd, Papum Pare, Arunachal Pradesh",
    rating: "4.7",
    ratingPercent: "92%",
    ratingsCount: "85",
    responseRate: "88%",
    whatsappConfirmed: false,
  },

  // Add more items if needed
];

const PowerTools = () => {
  return (
    <div className="main-box">
      <aside>
        <div className="flt-box-wrap">
          <div className="flt-box mb-0 flt-head">Filters By</div>
          <div className="flt-box bdrt-0">
            <p className="flt-title">Related Categories</p>
            <div className="flt-content">
              <ul className="flt-list cust-scroll">
                <li>
                  <Link to="#">Drills</Link>
                </li>
                <li>
                  <Link to="#">Grinders</Link>
                </li>
                <li>
                  <Link to="#">Saws</Link>
                </li>
                <li>
                  <Link to="#">Sanders</Link>
                </li>
                <li>
                  <Link to="#">Impact Drivers</Link>
                </li>
                <li>
                  <Link to="#">Nail Guns</Link>
                </li>
                <li>
                  <Link to="#">Angle Grinders</Link>
                </li>
                <li>
                  <Link to="#">Power Tools</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="flt-box">
            <p className="flt-title">By State</p>
            <div className="flt-content">
              <div className="flt-search">
                <input
                  type="text"
                  name="state_id"
                  placeholder="Search State"
                  id="state-search-input"
                />
              </div>
              <ul className="flt-list cust-scroll" id="state-lists">
                <li>
                  <Link to="#">All India</Link>
                </li>
                <li>
                  <Link to="#">Maharashtra</Link>
                </li>
                <li>
                  <Link to="#">Tamil Nadu</Link>
                </li>
                <li>
                  <Link to="#">Gujarat</Link>
                </li>
                <li>
                  <Link to="#">Madhya Pradesh</Link>
                </li>
                <li>
                  <Link to="#">Uttar Pradesh</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </aside>
      <main>
        <section className="section">
          <p className="sect-title">Explore by Categories</p>
          <div className="horprd expcatg" id="expcatg">
            <div className="item">
              <Link to="#">
                <div className="horprd-box">
                  <figure>
                    <img
                      src="/assets/too1.webp"
                      width={55}
                      height={55}
                      alt="Drills"
                    />
                  </figure>
                  <p className="title">Drills</p>
                </div>
              </Link>
            </div>
            <div className="item">
              <Link to="#">
                <div className="horprd-box">
                  <figure>
                    <img
                      src="/assets/too2.jpg"
                      width={55}
                      height={55}
                      alt="Grinders"
                    />
                  </figure>
                  <p className="title">Grinders</p>
                </div>
              </Link>
            </div>
            <div className="item">
              <Link to="#">
                <div className="horprd-box">
                  <figure>
                    <img
                      src="/assets/too3.jpg"
                      width={55}
                      height={55}
                      alt="Saws"
                    />
                  </figure>
                  <p className="title">Saws</p>
                </div>
              </Link>
            </div>
            <div className="item">
              <Link to="#">
                <div className="horprd-box">
                  <figure>
                    <img
                      src="/assets/too4.jpg"
                      width={55}
                      height={55}
                      alt="Sanders"
                    />
                  </figure>
                  <p className="title">Sanders</p>
                </div>
              </Link>
            </div>
            <div className="item">
              <Link to="#">
                <div className="horprd-box">
                  <figure>
                    <img
                      src="/assets/too5.jpg"
                      width={55}
                      height={55}
                      alt="Impact Drivers"
                    />
                  </figure>
                  <p className="title">Impact Drivers</p>
                </div>
              </Link>
            </div>
          </div>
        </section>
        <ul className="classfied-wrap">
          {classifiedData.map((item, index) => (
            <li key={index}>
              <div className="classified">
                <div className="prd-info">
                  <div className="prd-box">
                    <img
                      src={item.imgSrc}
                      alt={item.altText}
                      width={250}
                      height={250}
                    />
                  </div>
                </div>
                <div className="cinfo">
                  <div className="cbox">
                    <figure>
                      <span className="cmp-year">{item.years}</span>
                    </figure>
                    <div className="cboxr">
                      <Link to="#" target="_blank">
                        <h4 className="title">{item.companyName}</h4>
                      </Link>
                      <p className="cloc tooltip ellipsis">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={16}
                          height={16}
                          fill="currentColor"
                          className="bi-location"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
                        </svg>
                        {item.location}
                        <span className="tooltiptext">{item.tooltipText}</span>
                      </p>
                      <div className="rating-wrap">
                        <span className="rtbox">{item.rating}</span>
                        <span
                          className="crate"
                          style={{ "--_score": item.ratingPercent }}
                        />
                        <span className="rate-text">
                          {item.ratingsCount} Ratings
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="caddit">
                    <div className="item">
                      <div
                        className="ca-box modal-btn"
                        data-modal="motc"
                        data-src={item.trustCertificateUrl}
                      >
                        <p>
                          <i className="l3icon motc-icon" />
                        </p>
                      </div>
                    </div>
                    <div className="item">
                      <div className="ca-box">
                        <p>
                          <i className="l3icon resp-icon" />
                        </p>
                        <p>
                          <span>Response Rate</span> <b>{item.responseRate}</b>
                        </p>
                      </div>
                      <p>
                        <span>Main Products</span> <b>{item.mainProducts}</b>
                      </p>
                    </div>
                  </div>
                  <div className="caction">
                    <Link to={"/register-buyer"}>
                      <p>Contact Supplier</p>
                    </Link>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
};

export default PowerTools;
